<template>
  <div v-on:keypress="onkeypress">
    <b-row v-if="showQvButtons && qvbuttons">
      <b-col>
        <queryviewbuttonpanel :qvtype="qvtype" @select="selectButton"></queryviewbuttonpanel>
      </b-col>
    </b-row>
    <!-- <div class="markframe" v-bind:style="GetMarkedFrameStyle()" v-if="false && cellMarkSelecting">
      Håll nere Ctrl+knappen och dra med musen för att markera</div> -->
    <div class="row">
      <b-col>
        <div class="btn-toolbar mb-3" role="toolbar">
          <b-button variant="outline" @click="toggleQvButtons()" title="Visa/dölj Vytotaler" v-if="qvbuttons">
            <!-- <b-icon-gear></b-icon-gear> -->
            <b-icon-segmented-nav></b-icon-segmented-nav>
          </b-button>
          <div class="btn-group" role="group" v-if="toolbar">
            <b-dropdown slot="prepend" v-on:show="OnQvSelectorShown" v-bind:text="qvName" variant="primary"
              title="Välj vy (Ctrl+Alt+V)" style="width: 350px" ref="qvSelectorDropdown">
              <b-dropdown-form>
                <b-form-input size="sm" ref="qvSearchInput" v-model="filterQvList" placeholder="Sök..."
                  @keypress="QvSearchKeyPress"></b-form-input>
              </b-dropdown-form>
              <b-dropdown-item v-for="n in GetFilteredQvList(filterQvList)" :key="n.id" v-on:click="QvSelect(n.id)">
                <b-icon-person-badge-fill v-if="!n.pub" title="Privat vy"></b-icon-person-badge-fill>
                {{ n.name }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          &nbsp;
          <div class="btn-group" role="group" v-if="toolbar">
            <button type="button" class="btn btn-secondary" v-if="hasChanged">
              (Ändrad)
            </button>
            <button type="button" class="btn btn-secondary" v-on:click="showQueryViewSave = true" title="Spara vy">
              <!-- <i class="fas fa-save"></i> -->
              <b-icon-hdd />
            </button>
            <button v-if="hasChanged" type="button" class="btn btn-secondary" v-on:click="CancelChanges()"
              title="Återgå till sparad vy">
              <!-- <i class="fa fa-filter fa-xs mt-4"></i>
              <i class="fa fa-remove fa-xs mt-4"></i>-->
              <b-icon-funnel-fill />
              <b-icon-x-circle />
            </button>
          </div>
          &nbsp;
          <div class="btn-group" role="group" v-if="toolbar">
            <button type="button" class="btn btn-secondary" v-on:click="EditColumns()" title="Kolumnväljaren">
              <!-- <i class="fa fa-cog fa-xs mt-4"></i> -->
              <b-icon-gear />
            </button>
            <button type="button" class="btn btn-secondary" v-on:click="showExport = true" title="Exportera">
              <!-- <i class="fa fa-download fa-xs mt-4"></i> -->
              <b-icon-download />
            </button>

            <!-- <button type="button" class="btn btn-secondary" v-on:click="editCol(c)" title="Skriv ut">            
              <b-icon-printer />
            </button> -->

            <!-- <button
              type="button"
              class="btn btn-secondary"
              v-on:click="AddCalcCol()"
              title="Lägg till beräknad kolumn"
            >
              <i class="fa fa-plus"></i>
            </button>-->
          </div>
          &nbsp;
          <div class="btn-group" role="group" v-if="navbar">
            <button type="button" class="btn btn-secondary" v-on:click="GetData()" title="Ladda om data (Ctrl+Alt+F5)">
              <!-- <i class="fa fa-refresh"></i> -->
              <b-icon-arrow-repeat />
            </button>
            <button type="button" class="btn btn-secondary" v-on:click="CalcTotals()" title="Beräkna summering">
              <!-- <i class="fa fa-calculator fa-xs mt-4"></i> -->
              <b-icon-calculator />
            </button>
            <button type="button" class="btn btn-secondary" v-on:click="StepToPage(-1)" title="Föregående sida">
              <!-- <i class="fa fa-chevron-left"></i> -->
              <b-icon-caret-left />
            </button>
            <button type="button" class="btn btn-secondary" v-on:click="StepToPage(1)" title="Nästa sida">
              <!-- <i class="fa fa-chevron-right"></i> -->
              <b-icon-caret-right />
            </button>
            <button type="button" class="btn btn-secondary">
              Sida: {{ pageNo }}
            </button>
            <b-dropdown slot="prepend" v-bind:text="currSize.name" variant="secondary" title="Antal rader per sida">
              <b-dropdown-item v-for="n in pageSizes" :key="n.name" v-on:click="SetPageSize(n)">{{ n.name }}
              </b-dropdown-item>
            </b-dropdown>&nbsp;
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text" id="btnGroupAddon" v-on:click="searchFor = ''"
                  title="Nollställ sökning på sidan">                  
                  <b-icon-search></b-icon-search>
                  <!-- <i class="fa fa-search fa-xs mt-4"></i> -->
                </div>
              </div>
              <input v-model="searchFor" type="text" class="form-control" placeholder="Sök på sidan" ref="searchOnPage"
                aria-label="Sök på sidan" aria-describedby="btnGroupAddon" />
              <div class="input-group-append">
                <span class="input-group-text" title="Antal rader som visas/totala antalet rader på sidan">{{
                this.noOfRows
                }}/{{ rows.length }}</span>
                <span class="input-group-text" title="Antal markerade rader">
                  <i class="fa fa-check-square-o fa-lg mt-4"></i>
                  &nbsp;
                  {{ noOfSelectedRows }}
                </span>
              </div>              
              <div class="input-group-text" v-if="cellMarkActive">
                <b-icon-x-circle-fill v-if="!cellMarkSelecting" @click="cellMarkActive=false" title="Stäng markering">
                </b-icon-x-circle-fill>
                Snabbklipp ({{cellMarkEnd.cellidx-cellMarkStart.cellidx+1}}x{{cellMarkEnd.rowidx-cellMarkStart.rowidx+1}}):
                <b-icon icon="bullseye" v-if="cellMarkSelecting"></b-icon>
                <b-button variant="none" size="sm" title="Markera hela kolumner" @click="MarkedCellMarkAll(true)">
                  <b-icon-distribute-horizontal></b-icon-distribute-horizontal>
                </b-button>
                <b-button variant="none" size="sm" title="Markera hela rader" @click="MarkedCellMarkAll(false)">
                  <b-icon-distribute-vertical></b-icon-distribute-vertical>
                </b-button>
                <b-dropdown slot="prepend" text="" variant="none" size="sm" title="Kopiera till urklipp"
                  v-if="!cellMarkSelecting" @click="MarkedCellsCopy(false, $event)">
                  <template #button-content>
                    <b-icon-clipboard>
                    </b-icon-clipboard>
                  </template>
                  <b-dropdown-item @click="MarkedCellsCopy(true)">Kopiera till urklipp (med rubriker)</b-dropdown-item>
                  <b-dropdown-item @click="MarkedCellsCopy(false)">Kopiera till urklipp (utan rubriker)</b-dropdown-item>
                </b-dropdown>
                <b-button variant="none" size="sm" title="Markera rader" v-if="!cellMarkSelecting"
                  @click="MarkedCellsMarkRows(true)">
                  <b-icon-check-circle></b-icon-check-circle>
                </b-button>
                <b-button variant="none" size="sm" title="Avmarkera rader" v-if="!cellMarkSelecting"
                  @click="MarkedCellsMarkRows(false)">
                  <b-icon-circle></b-icon-circle>
                </b-button>                
              </div>
              <div class="input-group-append">
                <b-button variant="outline" title="Visa snabbkommandon"><b-icon-keyboard @mouseenter="ShowHelp()"></b-icon-keyboard></b-button>                
              </div>             
              <div class="input-group-append" v-if="isBusy">
                <b-icon icon="arrow-clockwise" animation="spin" font-scale="2"></b-icon>
              </div>             
            </div>
          </div>
        </div>
      </b-col>

      <b-col cols="1"></b-col>
    </div>
    <div class="section-to-print">
      <table class="qv-table">
        <thead>
          <tr>
            <th v-if="selectable">
              <!-- <i
              class="fa fa-check-square-o fa-lg mt-4"
              v-on:click="ToggleSelected()"
              title="Markera/Avmarkera alla på sidan"
            ></i>-->
              <b-icon-check-circle title="Markera/Avmarkera alla på sidan" v-on:click="ToggleSelected()" />
            </th>
            <th v-if="cmdcolumn">
              <slot name="cmdcolheader"></slot>
            </th>
            <th v-for="hi in hovericons" :key="hi.id"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                fill="currentColor" class="bi bi-aspect-ratio" viewBox="0 0 16 16"></svg></th>
            <th v-for="(c, i) in GetVisibleColumns" :key="c.ColName" @mouseover="OnColHover(c)"
              @mouseleave="OnColUnHover()"
              v-bind:style="GetColStyle(c)" v-bind:class="GetColClass(c)">
              <!-- <i class="fa fa-sort-asc fa-xs mt-4" v-if="c.OrderBy=='asc'"></i> -->
              <b-icon-caret-up-fill v-if="c.OrderBy == 'asc'" />
              <!-- <i class="fa fa-sort-des c fa-xs mt-4" v-if="c.OrderBy=='desc'"></i> -->
              <b-icon-caret-down-fill v-if="c.OrderBy == 'desc'" />
              <!-- <i class="fa fa-filter fa-xs mt-4" v-if="c.Filter&&c.Filter!=''"></i> -->
              <b-icon-funnel-fill v-if="c.Filter && c.Filter !== '' && c.Filter !== '{}'" />
              <!-- <i class="fa fa-plus-square fa-xs mt-4" v-if="groupByColIdx==i"></i> -->
              <b-icon-plus-square-fill v-if="groupByColIdx == i" />

              <div v-if="hover === c" v-bind:class="{ qvcMenu: true }">
                <br />
                <b-card>
                  <b-card-title id="popover-helptext">{{ c.Name }}</b-card-title>
                  <b-card-body>
                    <div class="btn-group" role="group">
                      <button type="button" class="btn btn-secondary" v-on:click="SetSort(c,1)" title="Sortering stigande">
                        <b-icon-sort-down />
                      </button>
                      <button type="button" class="btn btn-secondary" v-on:click="SetSort(c,-1)" title="Sortering fallande">
                        <b-icon-sort-up />
                      </button>
                      <button type="button" class="btn btn-secondary" v-on:click="editFilter(c)" title="Filtrering">
                        <!-- <i class="fa fa-filter fa-xs mt-4"></i> -->
                        <b-icon-funnel />
                      </button>
                      <button v-if="c.Filter" type="button" class="btn btn-secondary" v-on:click="removeColumnFilter(c)"
                        title="Ta bort filtrering">
                        <b-icon-funnel-fill />
                        <b-icon-x-circle />
                      </button>
                      <button type="button" class="btn btn-secondary" v-on:click="editCol(c)"
                        title="Inställningar för kolumnen">
                        <!-- <i class="fa fa-cog fa-xs mt-4"></i> -->
                        <b-icon-gear />
                      </button>
                    </div>
                    <b-popover v-if="helpDescr" target="popover-helptext" triggers="hover" placement="top">
                      <template #title>{{ c.Name }}</template>
                      {{ helpDescr.description }}
                    </b-popover>
                  </b-card-body>
                </b-card>
              </div>
              {{ c.Name }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="totals.length > 0">
            <td v-if="selectable"></td>
            <td v-for="hi in hovericons" :key="hi.id"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                fill="currentColor" class="bi bi-aspect-ratio" viewBox="0 0 16 16"></svg></td>
            <td v-for="(c) in GetVisibleColumns" :key="c.ColName" v-bind:style="GetColStyle(c)"
              v-bind:class="GetColClass(c)">
              <div v-if="IsTotalCol(c)">
                <span class="badge badge-secondary">&sum;{{ GetTotal(c).Sum }}</span>
                <span class="badge badge-secondary">//{{ GetTotal(c).Avg }}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td v-bind:colspan="GetColCount">
              <div class="scrollit">
                <table class="disable-select">
                  <tr v-for="(r,rowidx) in GetRows()" :key="r._key" class="qv-row" :class="GetRowClass(r)">
                    <td v-if="selectable" @mouseenter="DragToggleSelectedRow(r,$event)">
                      <!-- <b-check v-model="r.selected"></b-check> -->
                      <!-- <input type="checkbox" v-model="r.selected" /> -->
                      <!-- <i class="fa fa-check-square-o" v-if="r.selected" @click="ToggleSelectedRow(r)"></i> -->
                      <b-icon-check-circle-fill v-if="r.selected" @click="ToggleSelectedRow(r,$event)" />
                      <!-- <i class="fa fa-circle-thin" v-if="!r.selected" @click="ToggleSelectedRow(r)"></i> -->
                      <b-icon-circle v-if="!r.selected" @click="ToggleSelectedRow(r,$event)" />
                    </td>
                    <td v-if="cmdcolumn">
                      <slot name="cmdcolrow"></slot>
                    </td>
                    <td v-for="hi in hovericons" :key="hi.id">
                      <i v-bind:class="GetHoverIconClass(hi)" @mouseover="IconHover($event, hi, r)"
                        @mouseleave="IconUnHover($event, hi, r)"></i>
                    </td>
                    <td v-for="(c, i) in r.Cells" :key="i" v-on:click="CellClicked($event,c,r,i,rowidx)"
                      v-on:mousemove="CellMouseMove($event,c,r,i,rowidx)" v-bind:style="GetCellStyle(i, r)"
                      v-bind:class="GetCellClass(i, r, rowidx)" v-show="columns[i].Visible">
                      {{ c }}
                    </td>
                    <!-- v-bind:class="GetCellClass(i,r)" -->
                  </tr>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <b-modal title v-model="showColFilterModal" @ok="setColumnFilter()">
      <queryviewfilter v-if="colToEdit" v-bind:column="colToEdit" @change="changeColFilter"></queryviewfilter>
    </b-modal>
    <b-modal title v-model="showColSettingsModal" @ok="setColumn(colToEdit)" @cancel="GetData()">
      <queryviewcolumnstyle v-bind:column="colToEdit"></queryviewcolumnstyle>
    </b-modal>
    <b-modal title="Kolumnväljaren" v-model="showEditColumns" @ok="setEditColumns(editColumns)" size="xl">
      <queryviewmanager v-bind:columns="editColumns"></queryviewmanager>
    </b-modal>
    <b-modal title="Spara vy" v-model="showQueryViewSave" @ok="Save()">
      <div>
        <b-row>
          <b-col>
            <label>Spara som namn:</label>
            <br />
            <b-input v-model="qvName" />
          </b-col>
        </b-row>
        <b-row>
          <b-form-checkbox v-if="HasPermission('ADM')" v-model="ispublic">Offentlig</b-form-checkbox>
        </b-row>
        <b-row>
          <b-col align-h="end">
            <b-button v-if="HasPermission('ADM')||!ispublic" @click="RemoveView()">Ta bort vy</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal title="Exportera" v-model="showExport" ok-only ok-variant="secondary" ok-title="Avbryt">
      <!-- <template v-slot:modal-footer>
        <div class="w-100">
          <p class="float-left">Modal Footer Content</p>
          <b-button variant="primary" size="sm" class="float-right" @click="show=false">Stäng</b-button>
        </div>
      </template>-->
      <queryviewexport v-bind:id="id" v-bind:startRow="getStartRow()" v-bind:endRow="getEndRow()"></queryviewexport>
    </b-modal>
    <!-- <b-modal title="Beräknad kolumn" v-model="showCalcColModal" @ok="setEditColumns(editColumns)">
      <queryviewcalcfield></queryviewcalcfield>
    </b-modal> -->
    <!-- TODO: Move to generic component -->
    <!-- <div v-shortkey.once="['ctrl', 'alt', 'v']" @shortkey="SelectView()"></div>
    <div v-shortkey.once="['ctrl', 'alt', 'f']" @shortkey="SearchOnPage()"></div>
    <div v-shortkey.once="['ctrl', 'alt', 'f5']" @shortkey="GetData()"></div>
    <div v-shortkey.once="['ctrl', 'alt']" @shortkey="ShowHelp()"></div> -->
    <div v-for="(k) in GetShortKeys" :key="k.name" v-shortkey.once="k.keys" @shortkey="ShortKeyHandle(k)">
    </div>
  </div>
</template>
<script>
import { Api } from "../../lib/api";
import { isNumber } from "util";
import queryviewfilter from "./queryviewfilter";
import queryviewcolumnstyle from "./queryviewcolumnstyle";
import queryviewmanager from "./queryviewmanager";
// import queryviewsave from "./queryview-save";
import queryviewexport from "./queryviewexport";
// import queryviewcalcfield from "./queryviewcalcfield";
import queryviewbuttonpanel from "./queryviewbuttonpanel";
import User from "../../lib/user";
const usr = new User();
import { ShortKey } from "vue-shortkey";

const api = new Api();
const minColWidth = 50;

const shortKeys = [
  {keys: ['ctrl', 'alt'], name:'SelectMarked', description: 'Dra med musen för att markera'},
  {keys: ['ctrl', 'alt', 'v'], name:'SelectView', description: 'Vyväljaren  '},
  {keys: ['ctrl', 'alt', 'f'], name:'SearchOnPage', description: 'Sök på sidan'},
  {keys: ['ctrl', 'alt', 'f5'], name:'GetData', description: 'Ladda om data'},
  {keys: ['ctrl', 'alt', 'arrowright'], name:'SetNext', description: 'Sätt nästa'},
  {keys: ['ctrl', 'alt', 'arrowleft'], name:'SetPrev', description: 'Sätt föregående'},
]

export default {
  name: "queryview",
  components: {
    queryviewfilter,
    queryviewcolumnstyle,
    queryviewmanager,
    queryviewexport,
    // queryviewcalcfield,
    queryviewbuttonpanel,
    // queryviewsave
  },
  props: {
    qvtype: {
      type: String,
      default: "",
    },
    selectable: Boolean,
    cmdcolumn: Boolean,
    currentkey: null,
    hovericons: { type: Array },
    extrafilter: null,
    toolbar: { type: Boolean, default: true },
    navbar: { type: Boolean, default: true },
    qvbuttons: { type: Boolean, default: false },
  },
  data() {
    return {
      id: 0,
      columns: [],
      rows: [],
      info: "",
      pageNo: 1,
      qvList: [],
      qvName: "",
      ispublic: true,
      hover: null,
      colToEdit: null,
      showColFilterModal: false,
      showColSettingsModal: false,
      showCalcColModal: false,
      pageSizes: [
        { name: "25/sida", size: 25 },
        { name: "100/sida", size: 100 },
        { name: "1000/sida", size: 1000 },
        { name: "(valfritt)", size: 1000, prompt:true },
        //{ name: "(ALLA)", size: 9999999 },
      ],
      currSize: {},
      editColumns: [],
      showEditColumns: false,
      showQueryViewSave: false,
      showExport: false,
      searchFor: "",
      lastSearchFor: "",
      totals: [],
      hasChanged: false,
      noOfRows: 0,
      noOfSelectedRows: 0,
      groupByColIdx: null,
      grpBy: [],
      isBusy: false,
      showQvButtons: false,
      //cellcss: [],
      waiting: false,
      filterQvList: null,
      helpDescr: null,
      helpDescrRepository: [],
      cellMarkActive: false,
      cellMarkSelecting: false,
      cellMarkStart: { cellidx: 0, rowidx: 0 },
      cellMarkEnd: { cellidx: 0, rowidx: 0 },
      // cellMarkFrameX1: 0,
      // cellMarkFrameY1: 0,
      // cellMarkFrameX2: 0,
      // cellMarkFrameY2: 0,
    };
  },
  created() {
    //alert(this.qvtype);
    this.currSize = this.pageSizes[1];
    if (!this.rows || this.rows.length == 0) this.GetData();
    this.GetQueryViewList();
    this.showQvButtons =
      localStorage.getItem("qpanels_show_" + this.qvtype) === "true";
  },
  watch: {
    searchFor: function (v, ov) {
      console.log("SerchFor changed:" + ov + "->" + v);
      setTimeout(() => {
        if (this.lastSearchFor !== this.searchFor)
          this.UpdateSearch(this.searchFor);
      }, 1000);
      //this.throttle(() => this.UpdateSearch(v), 5000);
    },
    extrafilter: function (v, ov) {
      if (v != ov) this.GetData();
    },
  },
  computed: {
    GetVisibleColumns: function () {
      if (!this.columns || this.columns.length == 0) return [];
      return this.columns.filter((x) => x.Visible);
    },
    GetColCount: function () {
      if (!this.columns || this.columns.length == 0) return 0;

      var res = this.selectable ? 1 : 0;
      res += this.hovericons ? this.hovericons.length : 0;
      res += this.columns.filter((x) => x.Visible).length;

      return res;
    },
    GetShortKeys: function() {
      return shortKeys;
    }
  },
  methods: {
    ShowHelp() {
      //alert('Showhelp');      
      var msg = shortKeys.map(k =>  '['+k.keys.join('+')+']-'+k.description).join('\n');
      this.$bvToast.toast(msg, {
          title: 'Snabbkommandon',
          autoHideDelay: 5000,
          appendToast: false,
          variant: 'info'
        })
    },
    HasPermission(perm) {
      return usr.HasPermission(perm);
    },
    ShortKeyHandle(skey) {
      switch(skey.name.toLowerCase()) {
        case 'showhelp':
          this.ShowHelp();
          break;
        case 'selectview':
          this.SelectView();
          break;
        case 'searchonpage':
          this.SearchOnPage();
          break;
        case 'getdata':
          this.GetData();
          break;
        case 'setnext':
          this.StepCurrent(1);
          break;
          case 'setprev':
          this.StepCurrent(-1);
          break;
        case 'selectmarked':
          //Do nothing
          break;
        default:
          alert('Kunde inte utföra kortkommandot.');
      };
      this.$bvToast.toast( skey.description, {
          title: 'Snabbkommando:'+'['+skey.keys.join('+')+']',
          autoHideDelay: 1000,
          appendToast: false,
          variant: 'info'
        });
    },
    SelectView() {      
      this.$refs.qvSelectorDropdown.show(true);
    },
    SearchOnPage() {
      this.$refs.searchOnPage.focus();
    },
    GetFilteredQvList(filter) {
      if (!this.qvList)
        return [];

      var res = this.qvList;
      if (filter) {
        var flt = filter.toUpperCase();
        res = res.filter(x => x.name.toUpperCase().indexOf(flt) >= 0);
      }
      return res;
    },
    QvSearchKeyPress(ev) {
      if (ev.key == 'Enter') {
        var qs = this.GetFilteredQvList(this.filterQvList);
        if (qs.length > 0) {
          this.QvSelect(qs[0].id);
          this.filterQvList = null;
          this.$refs.qvSelectorDropdown.hide(true);
        }
      }
      console.log(ev);
    },
    OnQvSelectorShown(ev) {
      //this.$refs.qvSearchInput.focus();
      setTimeout(() => {
        this.$refs.qvSearchInput.focus();
      }, 500);
    },
    GetVisibleCells(row) {
      //Det här borde väl filtreras bort redan vid inläsning
      if (row) {
        var res = [];
        for (var i = 0; i < this.Columns.length; i++)
          if (this.Columns[i].Visible) res.push(row.Cells[i]);
        return res;
      }
    },
    StepCurrent(steps) {
      if (this.currentkey) {
        var rows = this.GetRows();
        if (rows.length > 0) {
          var idx = rows.findIndex((x) => x._key == this.currentkey);
          if (idx >= 0) {
            idx += steps;
            if (idx >= rows.length) idx = rows.length - 1;
            if (idx < 0) idx = 0;
            //this.currentkey = rows[idx]._key;
            this.$emit("currentkeychanged", rows[idx]);
          }
        }
      }
    },
    GetColStyle(c) {
      //Instead of object, return string
      var res = [];

      // if (c.Width > 0) {
      //   res.push("width:" + c.Width + "px");
      // }
      res.push(
        "width:" +
        (c.Width && c.Width > minColWidth ? c.Width : minColWidth) +
        "px"
      );
      if (c.csf) {
        if (c.csf.align && c.csf.align > 0) {
          res.push("text-align:" + (c.csf.align === 1 ? "center" : "right"));
        }
      }
      return res.join(";");

      // var res = {};
      // if (c.Width > 0) {
      //   //return { width: c.Width + 'px' };
      //   res.width = c.Width + "px";
      // }
      // if (c.csf) {
      //   if (c.csf.align && c.csf.align > 0) {
      //     res["text-align"] = c.csf.align === 1 ? "center" : "right";
      //   }
      // }
      // return res;
    },
    GetColClass(c) {
      return "fixedcell";
      //if (c.Width > 0) return "fixedcell";

      //return null;
    },
    GetCellClass(cidx, row, rowidx) {

      var res = this.GetColClass(this.columns[cidx]);
      if (this.IsCellMarked(cidx, rowidx))
        res += " qvcellmarked";
      return res;
    },
    GetCellStyle(cidx, row) {
      var res = [];
      res.push(this.GetColStyle(this.columns[cidx]));

      if (row.cs) {
        var c = row.cs[cidx];
        if (c) res.push(c);
      }
      return res.join(";");
      //return res;
    },
    MarkedCellMarkAll(columns) {
      if (columns) {
        this.cellMarkStart.rowidx = 0;
        this.cellMarkEnd.rowidx = this.GetRows().length-1;
      } else {
        this.cellMarkStart.cellidx = 0;
        this.cellMarkEnd.cellidx = this.GetVisibleColumns.length-1;
      }
    },
    MarkedCellsCopy(includeTitles,ev) {
      let res = [];
      if(ev)
        ev.preventDefault();
        
      if (includeTitles) {
        var titles = [];
        for (let c = this.cellMarkStart.cellidx; c <= this.cellMarkEnd.cellidx; c++)
          titles.push(this.GetVisibleColumns[c].Name);
        res.push(titles.join('\t'));
      }

      let rows = this.GetRows();
      for (let i = this.cellMarkStart.rowidx; i <= this.cellMarkEnd.rowidx; i++) {
        let r = rows[i];
        let resRow = [];
        for (let c = this.cellMarkStart.cellidx; c <= this.cellMarkEnd.cellidx; c++) {
          if (this.columns[c].Visible) {
            resRow.push(r.Cells[c]);
          }
        }
        res.push(resRow.join('\t'));
      }
      let clpText = res.join('\n');
      navigator.clipboard.writeText(clpText);
    },
    MarkedCellsMarkRows(selected) {
      var rows = this.GetRows();
      for (var i = this.cellMarkStart.rowidx; i <= this.cellMarkEnd.rowidx; i++)
        this.SetSelectedRow(rows[i], selected);
    },
    // GetMarkedFrameStyle() {
    //   if (this.cellMarkSelecting) {
    //     var x1 = this.cellMarkFrameX1;
    //     var x2 = this.cellMarkFrameX2;
    //     var y1 = this.cellMarkFrameY1;
    //     var y2 = this.cellMarkFrameY2;

    //     var top = Math.min(y1, y2);
    //     var left = Math.min(x1, x2);
    //     var width = Math.abs(x1 - x2);
    //     var height = Math.abs(y1 - y2);

    //     return `top:${top}px; left: ${left}px; width: ${width}px; height: ${height}px`;
    //   }
    // },
    GetTotal(c) {
      if (this.totals) {
        var t = this.totals.find(x => x.ColumnName == c.ColName);
        return t;
      }
      return null;
    },
    IsTotalCol(c) {
      var t = this.GetTotal(c);
      return t ? t.Show : false;
    },
    GetRowClass(r) {
      if (r._key == this.currentkey) return "current";

      return r.RowStyle;
    },
    SetBusyState(state) {
      this.isBusy = state;
    },
    GetHoverIconClass(hi) {
      var res = { fa: true };
      res["fa-" + hi.icon] = true;
      return res;
    },
    IconHover(ev, hi, r) {
      this.$emit("iconhover", { ev: ev, hovericon: hi, row: r });
    },
    IconUnHover(ev, hi, r) {
      this.$emit("iconunhover", { ev: ev, hovericon: hi, row: r });
    },
    GotoPage(pg) {
      if (isNumber(pg) && pg > 0) {
        this.pageNo = pg;
        this.GetData();
      }
    },
    StepToPage(step) {
      this.pageNo = parseInt(this.pageNo) + step;
      if (this.pageNo < 1) {
        this.pageNo = 1;
        return;
      }
      this.GetData();
    },
    GetRows() {
      return this.rows.filter((x) => !x.hidden);
    },
    UpdateGroups() {
      if (!this.groupBy || this.groupBy == "") {
        this.groupByColIdx = null;
        this.grpBy = [];
        return;
      }

      var res = this.GetRows();
      if (this.groupBy && this.groupBy != "") {
        this.groupByColIdx = this.columns.findIndex(
          (x) => x.ColName == this.groupBy
        );
        if (this.groupByColIdx > 0) {
          var res2 = res.sort((a, b) =>
            a.Cells[this.groupByColIdx] < b.Cells[this.groupByColIdx] ? -1 : 1
          );
          this.grpBy = [];
          var prev = { val: null, cnt: 0 };
          for (var i = 0; i < res2.length; i++) {
            var currVal = String(
              this.rows[i].Cells[this.groupByColIdx]
            ).toUpperCase();
            if (!prev.val) prev = { val: currVal, cnt: 0 };
            if (prev.val != currVal) {
              if (prev.cnt > 1) {
                this.grpBy.push(prev);
                prev = { val: currVal, cnt: 0 };
              }
            }
            prev.cnt++;
          }
        }
      }
      return res;
    },
    UpdateSearch(sf) {
      //console.log("Update search:" + sf);
      this.lastSearchFor = sf;
      if (sf == "") {
        this.rows.map((x) => (x.hidden = false));
        this.noOfRows = this.rows.length;
        return;
      }

      var cnt = 0;
      var toSf = sf.toLowerCase();
      this.rows.map((x) => {
        if (x.search.indexOf(toSf) >= 0) {
          x.hidden = false;
          cnt++;
        } else {
          x.hidden = true;
        }
      });
      this.noOfRows = cnt;
    },
    getStartRow() {
      return (this.pageNo - 1) * this.currSize.size;
    },
    getEndRow() {
      return this.getStartRow() + this.currSize.size - 1;
    },
    GetData() {
      if (this.id == 0) return;
      this.SetBusyState(true);
      this.totals = [];

      var url = "/api/apiqueryview/getjson?id=" + this.id;
      var startRow = this.getStartRow(); //(this.pageNo - 1) * this.currSize.size;
      var endRow = this.getEndRow(); // startRow + this.currSize.size - 1;
      //url += "?StartRow=" + startRow + "&EndRow=" + endRow;
      url += "&StartRow=" + startRow + "&EndRow=" + endRow;
      if (this.extrafilter) url += "&extrafilter=" + this.extrafilter;
      api.get(url).then((response) => {
        this.SetBusyState(false);
        this.info = "";
        this.columns = response.data.Columns;
        //Parse CsFormat
        this.columns.map((c) => {
          if (c.CsFormat && c.CsFormat.length > 0)
            c.csf = JSON.parse(c.CsFormat);
        });
        this.rows = response.data.Rows;
        this.groupBy = response.data.GroupBy;
        // this.searchRows = [];
        this.ispublic = response.data.Public;
        for (var i = 0; i < this.rows.length; i++) {
          this.rows[i].search = this.rows[i].Cells.join("|").toLowerCase();
          this.rows[i].selected = false;
        }
        //Conditional formatting - csf
        var cs = [];
        for (var col = 0; col < this.columns.length; col++)
          if (this.columns[col].csf && this.columns[col].csf.cnds) {
            var cnds = this.columns[col].csf.cnds;
            for (var i = 0; i < this.rows.length; i++) {
              if (!this.rows[i].cs) this.rows[i].cs = [];
              this.rows[i].cs[col] = this.CalcCellStyle(
                cnds,
                this.rows[i].Cells[col]
              );
            }
          }

        var noOfZeroWidthCols = 0;
        var sumSetWidth = 0;
        this.columns.map((x) => {
          if (x.Visible) {
            if (!x.Width) noOfZeroWidthCols++;
            else sumSetWidth += x.Width;
          }
        });
        if (noOfZeroWidthCols > 0) {
          var restWidth = document.body.offsetWidth * 0.9 - sumSetWidth;
          if (restWidth < minColWidth * noOfZeroWidthCols)
            restWidth = minColWidth * noOfZeroWidthCols;
          var zeroWidth = Math.round(restWidth / noOfZeroWidthCols);
          this.columns
            .filter((x) => x.Visible && !x.Width)
            .map((x) => (x.Width = zeroWidth));
        }

        this.UpdateSearch(this.searchFor);
        this.UpdateGroups();
      });
    },
    CalcCellStyle(cnds, v) {
      //Example cnd: {"type":"bwn", "min":1, "max":null, "css":"qvcell1"}
      if (cnds) {
        var vd = this.GetNum(v);
        for (var i = 0; i < cnds.length; i++) {
          var cnd = cnds[i];
          switch (cnd.type) {
            case "bwn": //Between
              if (
                (!cnd.min || vd >= this.GetNum(cnd.min)) &&
                (!cnd.max || vd <= this.GetNum(cnd.max))
              )
                return this.GetCndStyle(cnd);
          }
        }
      }
    },
    GetNum(s) {
      if (s) {
        //console.log(s);
        if (typeof s === "string")
          return Number(s.replace(",", ".").replaceAll(" ", ""));
        return s;
      }
    },
    GetCndStyle(cnd) {
      if (cnd) {
        var res = [];
        if (cnd.bgcolor) res.push("background-color: " + cnd.bgcolor);
        if (cnd.color) res.push("color: " + cnd.color);
        return res.join(";");
      }

      return;
    },
    GetQueryViewList() {
      this.SetBusyState(true);

      api
        .get("/api/apiqueryview/GetQueryViewList?queryviewtype=" + this.qvtype)
        .then((res) => {
          this.SetBusyState(false);
          this.qvList = res.data;
          var selectedQv = this.qvList.find((x) => {
            return x.selected == true;
          });
          this.qvName = selectedQv.name;
          if (this.id != selectedQv.id) {
            // this.id = selectedQv.id;
            // this.GetData();
            this.QvSelect(selectedQv.id);
          }
        });
    },
    CalcTotals() {
      if (this.totals.length > 0) {
        this.totals = [];
        return;
      }
      //BYT TILL API
      this.SetBusyState(true);
      api.get("/api/apiqueryview/CalcTotals/" + this.id).then((res) => {
        this.totals = res.data;
        this.SetBusyState(false);
      });
    },
    QvSelect(id) {
      var data = { id: id, type: this.qvtype };
      this.hasChanged = false;
      this.SetBusyState(true);
      api.post("/api/apiqueryview/SetCurrentQueryView", data).then(() => {
        this.SetBusyState(false);
        this.qvName = this.qvList.find((x) => x.id == id).name;
        this.id = id;
        this.pageNo = 1;
        this.GetData();
      });
    },
    SetSort(c,dir) {
      var data = c.id;
      this.hasChanged = true;
      this.SetBusyState(true);
      
      api.post(`/api/apiqueryview/SetColumnSort?id=${c.id}&direction=${dir}`, data).then(() => {
        this.SetBusyState(false);
        this.GetData();
      });
    },
    SetCellMark(cellidx, rowidx) {
      if (!this.cellMarkSelecting) {
        this.cellMarkStart = { cellidx: cellidx, rowidx: rowidx }
        this.cellMarkSelecting = true;
      }
      this.cellMarkEnd = { cellidx: cellidx, rowidx: rowidx };
      console.log(this.cellMarkEnd);
    },
    IsCellMarked(cellidx, rowidx) {
      if (this.cellMarkActive) {
        //let cm = this.cellMark;
        return (cellidx >= this.cellMarkStart.cellidx && rowidx >= this.cellMarkStart.rowidx)
          && (cellidx <= this.cellMarkEnd.cellidx && rowidx <= this.cellMarkEnd.rowidx)
      }
      return false;
    },
    CellMouseMove(ev, cell, row, cellidx, rowidx) {
      if (ev.ctrlKey && ev.buttons == 1) {
        //alert('Både mousedown och ctrl');
        this.cellMarkActive = true;
        // if (!this.cellMarkSelecting) {
        //   this.cellMarkFrameX1 = ev.pageX;
        //   this.cellMarkFrameY1 = ev.pageY;
        // }
        this.SetCellMark(cellidx, rowidx);
      } else
        this.cellMarkSelecting = false;

      // this.cellMarkFrameX2 = ev.pageX;
      // this.cellMarkFrameY2 = ev.pageY;
    },
    CellClicked(ev, cell, row, cellidx, rowidx) {
      if (ev.ctrlKey) {
        ev.preventDefault();
      } else {
        this.RowClicked(row);
      }

    },
    RowClicked(row) {
      row.obj = this.GetRowAsObject(row);
      this.$emit("rowclicked", row);
    },
    GetRowAsObject(row) {
      var res = {};
      for (var i = 0; i < row.Cells.length; i++)
        res[this.columns[i].ColName] = row.Cells[i];

      return res;
    },
    editFilter(c) {
      this.colToEdit = c;
      this.showColFilterModal = true;
    },
    editCol(c) {
      this.colToEdit = c;
      this.showColSettingsModal = true;
    },
    changeColFilter(flt) {
      this.colToEdit.Filter = JSON.stringify(flt);
    },
    removeColumnFilter(c) {
      this.colToEdit = c;
      this.colToEdit.Filter = "";
      this.setColumnFilter();
    },
    setColumnFilter() {
      console.log(this.colToEdit);
      this.hasChanged = true;
      this.SetBusyState(true);

      api.post("/api/apiqueryview/SetColumn", this.colToEdit).then(() => {
        this.SetBusyState(false);
        this.GetData();
      });
      this.showColFilterModal = false;
      this.colToEdit = null;
    },
    setColumn(c) {
      this.hasChanged = true;
      this.SetBusyState(true);
      c.CsFormat = JSON.stringify(c.csf);
      api.post("/api/apiqueryview/SetColumn", c).then(() => {
        this.SetBusyState(false);
        this.GetData();
        this.hover = c;
      });
    },
    OnColHover(c) {
      this.hover = c;
      this.helpDescr = null;
      if (c) this.helpDescr = this.GetHelpDescr(c.ColName);
    },
    GetHelpDescr(keyName) {
      let k = keyName.toUpperCase();
      if (!this.helpDescrRepository[k]) {
        api.get("/api/apiqueryview/GetHelpDescription?keyName=" + k)
          .then(res => {
            this.helpDescr = res.data;
            this.helpDescrRepository[k] = res.data;
          }
          );
      }

      return this.helpDescrRepository[k];
    },
    OnColUnHover(c) {
      this.helpDscr = null;
      this.hover = null;
    },

    AdjWidth(c, adjustment) {
      if (!c.Width || c.Width == 0) c.Width = 50;
      c.Width += adjustment * 20;
      this.setColumn(c);
    },
    HideCol(c) {
      c.Visible = false;
      this.setColumn(c);
    },
    SetPageSize(n) {
      if(n.prompt) {
        var p = prompt('Ange antal per sida:', n.size);
        if(!p)
          return;
        n.size = Number(p);
      }
      this.currSize = n;
      this.pageNo = 1;
      this.GetData();
    },
    EditColumns() {
      this.showEditColumns = true;
      this.SetBusyState(true);
      api
        .get("/api/apiqueryview/GetQueryViewColumns?id=" + this.id)
        .then((res) => {
          this.SetBusyState(false);
          console.log(res);
          this.editColumns = res.data;
        });
    },
    setEditColumns(editColumns) {
      this.showEditColumns = false;
      this.hasChanged = true;
      this.SetBusyState(true);
      api
        .post("/api/apiqueryview/SetQueryViewColumns", editColumns)
        .then(() => {
          this.SetBusyState(false);
          this.GetData();
        });
    },
    RemoveView() {
      if (confirm("Vill du verkligen ta bort vyn?\n (GÅR EJ ATT ÅNGRA)")) {
        api.post("/api/apiqueryview/Remove?id=" + this.id).then((res) => {
          if (res.data) {
            alert(res.data);
            return;
          }
          alert("Vyn borttagen!");
          this.showQueryViewSave = false;
          var newView = this.qvList.indexOf((x) => x.id != this.id);
          this.QvSelect(newView.id);
        });
      }
    },
    Save() {
      this.SetBusyState(true);
      var b = { id: this.id, name: this.qvName, ispublic: this.ispublic };
      api.post("/api/apiqueryview/SaveQueryView", b).then(() => {
        this.SetBusyState(false);
        this.GetQueryViewList();
        this.hasChanged = false;
      });
    },
    CancelChanges() {
      this.QvSelect(this.id);
    },
    ToggleSelected() {
      var rs = this.GetRows();
      if (rs.length == 0) return;
      var v = !rs[0].selected;
      console.log("Set selected:" + v);
      //this.GetRows().map(r => (r.selected = v));
      for (var i = 0; i < this.rows.length; i++) {
        if (!this.rows[i].hidden) this.rows[i].selected = v;
      }
      let sr = this.GetSelectedRows();
      this.noOfSelectedRows = sr.length;
      this.$forceUpdate();
      this.$emit('selectionchanged', sr);
    },
    ToggleSelectedRow(r, e) {
      e.stopPropagation();
      this.SetSelectedRow(r, !r.selected)
    },
    SetSelectedRow(r, isSelected) {
      if (r.selected != isSelected) {
        r.selected = isSelected;
        let sr = this.GetSelectedRows();
        this.noOfSelectedRows = sr.length;
        this.$emit('selectionchanged', sr);
        this.$forceUpdate();
      }
    },
    DragToggleSelectedRow(r, e) {
      if (e.buttons) {
        e.stopPropagation();
        this.SetSelectedRow(r, true);
      }
    },
    GetRowById(id) {
      var r = this.rows.filter((x) => x._key == id);
      if (r.length == 0) return null;
      return r[0];
    },
    IsSelectedId(id) {
      var r = GetRowById(id);
      return r[0].selected;
    },
    GetSelectedRows() {
      return this.rows.filter((x) => x.selected);
    },
    AddCalcCol() {
      this.showCalcColModal = !this.showCalcColModal;
    },
    selectButton(b) {
      //alert(b.queryid);
      this.QvSelect(b.queryid);
    },
    toggleQvButtons() {
      this.showQvButtons = !this.showQvButtons;
      localStorage.setItem("qpanels_show_" + this.qvtype, this.showQvButtons);
    },
    // throttle (callback, limit) {
    //   if (!this.waiting) {                       // If we're not waiting
    //       callback();  // Execute users function
    //       this.waiting = true;                   // Prevent future invocations
    //       setTimeout(function () {          // After a period of time
    //           this.waiting = false;              // And allow future invocations
    //       }, limit);
    //   }
    // },
    onkeypress(ev) {
      console.log(ev);
    },
  },
};
</script>
<style scoped>
.current {
  /* border-block-start-width: 5px;
  border-block-start-style: dashed;
  border-block-start-color: blue;
  border-block-end-width: 5px;
  border-block-end-style: dashed;
  border-block-end-color: blue; */
  background: rgb(216, 228, 232);
  filter: brightness(0.7);

  /* filter: invert(10%); */
}

.qv-row:not(.current) {
  border-block-start-width: 10px;
  border-block-end-width: 10px;
}

.fixedcell {
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  height: 20px;
}

.qvcellmarked {
  background-color: rgb(230,230,50);
  filter: brightness(0.9);
  opacity: 0.9; 
  /* 90% didnt work in build */
}

.markframe {
  position: absolute;
  z-index: 100;
  background-color: brown;
  filter: brightness(0.7);
  opacity: 40%;
}

.alnright {
  text-align: right;
}

.alncenter {
  text-align: center;
}

.helptext {
  background-color: yellow;
  width: 100px;
  max-width: 150px;
  height: 100px;
  /* position: relative;   */
  word-break: break-all;
  font-weight: 100;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
}

.scrollit {
  overflow: auto;
  max-height: 75vh;
}

@media print {
  body * {
    visibility: hidden;
  }

  .section-to-print,
  .section-to-print * {
    visibility: visible;
  }

  .section-to-print {
    position: absolute;
    left: 0;
    top: 0;
  }
}

.resizer {
  position: absolute;

}
</style>
